import { logEvent } from '@wolffun/analytics';
import { formatCurrency } from '@wolffun/system-currency';
import { BoxTypeName, currencyName } from '../types';

const concatString = (...args) => {
  return args.join('_');
};

export const logConnectWalletEvent = data => {
  const {
    THC,
    THG,
    email,
    userId,
    walletAddress,
    provider
  } = data;
  logEvent('Connectwallet', {
    THG_THC: concatString(THG.value.toString(), THC.value.toString()),
    Email: email || '',
    UserID: userId,
    WalletAdd: `account_${walletAddress}`,
    WalletProvider: provider
  });
};
export const logBoxPurchaseEvent = data => {
  const {
    boxNumber,
    boxType,
    boxName,
    currencyAmount,
    transactionId,
    THC,
    THG,
    userId
  } = data;
  logEvent('BoxPurchase', {
    BoxType: boxName || BoxTypeName[boxType],
    BoxNumber: boxNumber,
    Currency_Amount: concatString(currencyName[currencyAmount.token], formatCurrency(currencyAmount)),
    TransactionID: transactionId,
    THG_THC: concatString(THG.value.toString(), THC.value.toString()),
    UserID: userId
  });
};
export const logOpenBoxEvent = data => {
  const {
    boxAmount,
    boxType,
    THC,
    THG,
    userId,
    boxName
  } = data;
  logEvent('BoxOpen', {
    BoxType: boxName || BoxTypeName[boxType],
    BoxAmount: boxAmount,
    THG_THC: concatString(formatCurrency(THG), formatCurrency(THC)),
    UserID: userId
  });
};
export const logSellHeroEvent = data => {
  const {
    battleCapTHC,
    limitTHCBattleCap,
    heroTypeId,
    heroLevel,
    heroRarity,
    heroToken,
    price,
    skinRarity,
    heroId,
    trophyLevel,
    THC,
    THG,
    userId,
    transactionFee
  } = data;
  logEvent('SellHero', {
    HeroId: heroId,
    heroTypeId: heroTypeId.toString(),
    SkinRarerity: skinRarity.toString(),
    HeroRarerity: heroRarity.toString(),
    HeroToken: heroToken,
    Sellingprice_Currency: concatString(formatCurrency(price), currencyName[price.token]),
    Current_Limit: concatString(limitTHCBattleCap.toString(), battleCapTHC.toString()),
    HeroLevel_TrophyLevel: concatString(heroLevel.toString(), trophyLevel.toString()),
    THG_THC: concatString(formatCurrency(THG), formatCurrency(THC)),
    UserID: userId,
    Transactionfee_Currency: concatString(formatCurrency(transactionFee), currencyName[transactionFee.token])
  });
};
export const logStopSellHeroEvent = data => {
  const {
    battleCapTHC,
    limitTHCBattleCap,
    heroTypeId,
    heroLevel,
    heroRarity,
    heroToken,
    price,
    skinRarity,
    transactionId,
    trophyLevel,
    THC,
    THG,
    userId
  } = data;
  logEvent('StopSellHero', {
    TransactionID: transactionId,
    heroTypeId: heroTypeId.toString(),
    SkinRarerity: skinRarity.toString(),
    HeroRarerity: heroRarity.toString(),
    HeroToken: heroToken,
    Sellingprice_Currency: concatString(formatCurrency(price), currencyName[price.token]),
    Current_Limit: concatString(limitTHCBattleCap.toString(), battleCapTHC.toString()),
    HeroLevel_TrophyLevel: concatString(heroLevel.toString(), trophyLevel.toString()),
    THG_THC: concatString(formatCurrency(THG), formatCurrency(THC)),
    UserID: userId
  });
};
export const logBuyHeroEvent = data => {
  const {
    battleCapTHC,
    limitTHCBattleCap,
    heroTypeId,
    heroLevel,
    heroRarity,
    heroToken,
    price,
    skinRarity,
    transactionId,
    trophyLevel,
    THC,
    THG,
    userId
  } = data;
  logEvent('BuyHero', {
    TransactionID: transactionId,
    heroTypeId: heroTypeId.toString(),
    SkinRarerity: skinRarity.toString(),
    HeroRarerity: heroRarity.toString(),
    HeroToken: heroToken,
    PurchasePrice_Currency: concatString(formatCurrency(price), currencyName[price.token]),
    Current_Limit: concatString(limitTHCBattleCap.toString(), battleCapTHC.toString()),
    HeroLevel_TrophyLevel: concatString(heroLevel.toString(), trophyLevel.toString()),
    THG_THC: concatString(formatCurrency(THG), formatCurrency(THC)),
    UserID: userId
  });
};
export const logCoinChangeMarket = data => {
  const {
    price,
    transactionId,
    THC,
    THG,
    userId,
    source
  } = data;
  logEvent('CoinChangeMarket', {
    TransactionID: transactionId || '',
    Currency: currencyName[price.token],
    Amount: formatCurrency(price),
    Source: source,
    THG_THC: concatString(formatCurrency(THG), formatCurrency(THC)),
    UserID: userId
  });
};
export const logCreatAccountStart = () => {
  logEvent('CreateStart');
};
export const logCreateAccountLinkAddress = () => {
  logEvent('CreateLinkAddress');
};
export const logAccountCreatePolicy = () => {
  logEvent('CreatePolicy');
};
export const logCreatAccountFinish = () => {
  logEvent('CreateFinish');
};
export const logOnboardingStepOne = () => {
  logEvent('OnboardingStepOne');
};
export const logOnboardingStepTwo = () => {
  logEvent('OnboardingStepTwo');
};
export const logOnboardingStepThree = () => {
  logEvent('OnboardingStepThree');
};
export const logOnboardingStepFour = () => {
  logEvent('OnboardingStepFour');
};